import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiSettings } from "react-icons/fi";
import "./Header.css";
import SearchBar from "./SearchBar";
import NavigationIcons from "./NavigationIcons";
import UserProfile from "./UserProfile";
import TopNavigation from "./TopNavigation";
import { useAppRole } from "../context/UserRoleContext";
import Icon15 from "../img/a6fbc02e1270717ab963b6d5928edcec5bb01a1174b13c49daba957378db2aa2.png";

function Header({ onGlobalSearchOpen, isGlobalSearchOpen = false }) {
  const { canAccessConfiguration } = useAppRole();
  const location = useLocation();
  const isActive = location.pathname === "/configuration" || location.pathname.startsWith("/configuration/");

  return (
    <header className="desktop-header">
      <div className="header-top-row">
        <div className="header-logo-section">
          <img
            loading="lazy"
            src={Icon15}
            className="header-logo"
            alt="Nettles Logo"
          />
        </div>
        <div className="header-nav-section">
          <TopNavigation />
        </div>
        <div className="header-right-section">
          <SearchBar onOpen={onGlobalSearchOpen} isOpen={isGlobalSearchOpen} />
          <div className="header-actions">
            <NavigationIcons />
            {canAccessConfiguration && (
              <Link to="/configuration" className={`header-settings-link ${isActive ? "active" : ""}`} title="Configuration">
                <FiSettings className="header-settings-icon" />
              </Link>
            )}
            <div className="header-divider" />
            <UserProfile />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
